const Content = () => {
  return (
    <div>
      <h2 className="bold mb-5">Content</h2>

      <p>
        This is a page where you will be able to see content specific to this
        asset
      </p>
    </div>
  );
};

export default Content;
